import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth, homePathFor } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export function ProtectedRoute({ roles, children }) {
  const { user, ready } = useAuth();
  const location = useLocation();

  if (!ready || user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#EAF3EF]">
        <Loader2 className="h-8 w-8 animate-spin text-[#087A73]" />
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    // Admin is a superuser: allow access to any role-gated area (e.g. professional view)
    if (user.role !== "admin") {
      return <Navigate to={homePathFor(user.role)} replace />;
    }
  }
  return children;
}
